<template>
  <div>
    <div :class="['custom-code-block', codeBlockClass]" v-html="formattedMarkdown"></div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'; // 导入markdown-it库

export default {
  props: {
    markdown: { // 从父组件传递过来的Markdown文本
      type: String,
      required: true
    },
    codeBlockClass: { // 传递给代码块的样式类
      type: String,
      default: ''
    }
  },
  computed: {
    formattedMarkdown() {
      const md = new MarkdownIt(); // 创建markdown-it实例
      return md.render(this.markdown); // 使用markdown-it将Markdown文本渲染成HTML
    }
  }
};
</script>

<style>

.custom-code-block {
  /* 自定义代码块样式 */
 
  display: block;
  padding: 10px;
  border-radius: 5px;
  line-height:0.36rem;
}

/* 自定义代码行样式 */
.custom-code-block .code-line {
  /* 代码行样式 */
}

/* 自定义行号样式 */
.custom-code-block .line-number {
  /* 行号样式 */
}

</style>